import { InsightsRetention, PaybackRow } from '../../types/marketing';
import CohortGrid from './CohortGrid';
import DataTable, { DataTableColumn } from './DataTable';
import { formatAed, formatInt, formatPct } from './marketingMath';

const PAYBACK_COLUMNS: DataTableColumn<PaybackRow>[] = [
  { key: 'campaign', header: 'Campaign', accessor: (r) => (r.campaignKey === 'blended' ? 'All campaigns (blended)' : r.campaignKey), format: 'text' },
  { key: 'spend', header: 'Spend (AED)', accessor: (r) => r.spend, format: 'aed' },
  { key: 'paidGmvAed', header: 'Paid GMV (AED)', accessor: (r) => r.paidGmvAed, format: 'aed' },
  { key: 'estimatedTakeAed', header: 'Estimated take (AED)', accessor: (r) => r.estimatedTakeAed, format: 'aed' },
  { key: 'paybackRatio', header: 'Payback (take ÷ spend)', accessor: (r) => r.paybackRatio, format: 'pct' },
];

/** Spec 084 Value & retention tab — cohort grid, value tiles and payback. */
export default function RetentionSection({ data, range }: { data: InsightsRetention; range: { from: string; to: string; timezone: string } }) {
  const v = data.value;
  const tiles: [string, string, string, string?][] = [
    ['repeat-order-rate', 'Repeat-order rate', formatPct(v.repeatOrderRate),
      v.customersWithOrder == null ? undefined : `${formatInt(v.repeatCustomers)} of ${formatInt(v.customersWithOrder)} customers ordered again`],
    ['aov', 'Average order value', formatAed(v.aov)],
    ['revenue-per-sign-up', 'Revenue per sign-up', formatAed(v.revenuePerSignUp)],
    ['refunds', 'Refunds', formatInt(v.refunds)],
  ];
  return (
    <div className="mkt-section" data-testid="section-retention">
      <section className="mkt-card"><CohortGrid cohorts={data.cohorts} /></section>
      <div className="mkt-tiles" data-testid="value-tiles">
        {tiles.map(([id, label, value, sub]) => (
          <div key={id} className="mkt-tile">
            <span className="mkt-kpi__label">{label}</span>
            <span className="mkt-tile__value" data-testid={`value-${id}`}>{value}</span>
            {sub && <span className="mkt-kpi__sub">{sub}</span>}
          </div>
        ))}
      </div>
      <section className="mkt-card">
        <DataTable caption="Payback" columns={PAYBACK_COLUMNS} rows={data.payback} rowKey={(r) => r.campaignKey}
          emptyText="No spend in this range" exportMeta={range} testId="retention-payback" />
        <p className="mkt-foot">Estimated take uses the platform's average take rate on paid GMV. Per campaign once the app attributes sign-ups (Spec 079).</p>
      </section>
    </div>
  );
}
